/* CMC site sound (2026-10-08): pit lane ambience + key-moment sound effects. Off until the visitor turns it on.
   Cost when off: this file only (no audio download, no AudioContext). The ambience file (~3.6 MB, 8.5-min seamless
   loop of CMC's pit lane recording) is requested only after the visitor presses the header sound button.
   Effects are synthesized with Web Audio (no files). Ambience is muted on arcade game pages (games have their own
   audio), pauses in background tabs and while another audible video/audio plays, and resumes where it left off on the
   next page. Other scripts can trigger an effect with document.dispatchEvent(new CustomEvent('pf:sfx', {detail: 'podium'})). */
(function () {
  'use strict';
  if (window.PFSound) return;
  var KEY = 'pf_site_sound', POS = 'pf_amb_t', ARRIVE = 'pf_sfx_arrive';
  var AMB_VOL = 0.32, SFX_VOL = 0.5;
  var on = false, ac = null, sfxBus = null, amb = null, ambGain = null, src = '';
  var quiet = false, waiting = false, lastKey = 0, others = [];

  function get(k, store) { try { return (store || localStorage).getItem(k); } catch (e) { return null; } }
  function set(k, v, store) { try { (store || localStorage).setItem(k, v); } catch (e) {} }
  on = get(KEY) === '1';

  function gameOnPage() {
    return !!document.querySelector('script[src*="pf-audio-ios"],[data-pf-sound-quiet]');
  }
  function session(type) {   // 'ambient': mixes with the visitor's music and follows the ring/silent switch
    if (quiet) return;          // arcade game pages manage their own session (pf-audio-ios.js)
    try { if (navigator.audioSession && navigator.audioSession.type !== type) navigator.audioSession.type = type; } catch (e) {}
  }

  /* ---------- Web Audio ---------- */
  function ctx() {
    if (ac) return ac;
    var C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    try { ac = new C({ latencyHint: 'interactive' }); } catch (e) { try { ac = new C(); } catch (e2) { return null; } }
    sfxBus = ac.createGain();
    sfxBus.gain.value = SFX_VOL;
    sfxBus.connect(ac.destination);
    return ac;
  }
  function wake() {
    if (!ac || ac.state === 'running' || ac.state === 'closed') return;
    try { var p = ac.resume(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }

  /* ---------- Effects (short synthesized "computer" tones) ---------- */
  // n: [freq, endFreq|0, startOffset s, duration s, wave, level, vibratoHz|0]
  var FX = {
    on:      [[180, 720, 0, 0.22, 'triangle', 0.22, 0], [1440, 0, 0.2, 0.09, 'sine', 0.12, 0]],
    off:     [[720, 160, 0, 0.24, 'triangle', 0.18, 0]],
    cart:    [[880, 0, 0, 0.06, 'square', 0.05, 0], [1320, 0, 0.07, 0.11, 'square', 0.05, 0], [2640, 0, 0.12, 0.16, 'sine', 0.06, 0]],
    remove:  [[660, 440, 0, 0.12, 'triangle', 0.12, 0]],
    error:   [[220, 0, 0, 0.12, 'square', 0.04, 0], [196, 0, 0.13, 0.16, 'square', 0.04, 0]],
    podium:  [[1047, 0, 0, 0.08, 'triangle', 0.16, 0], [1319, 0, 0.08, 0.08, 'triangle', 0.16, 0],
              [1568, 0, 0.16, 0.08, 'triangle', 0.16, 0], [2093, 0, 0.24, 0.42, 'triangle', 0.16, 7], [3136, 0, 0.26, 0.4, 'sine', 0.05, 7]],
    arcade:  [[220, 1760, 0, 0.32, 'sine', 0.2, 28], [1760, 0, 0.3, 0.06, 'square', 0.04, 0], [2349, 0, 0.37, 0.12, 'square', 0.04, 0]],
    coin:    [[1175, 0, 0, 0.06, 'square', 0.045, 0], [1760, 0, 0.06, 0.2, 'sine', 0.12, 0]],
    open:    [[520, 780, 0, 0.09, 'sine', 0.12, 0]],
    close:   [[780, 520, 0, 0.09, 'sine', 0.1, 0]],
    submit:  [[784, 0, 0, 0.05, 'sine', 0.12, 0], [1047, 0, 0.06, 0.05, 'sine', 0.12, 0], [1568, 0, 0.12, 0.14, 'sine', 0.12, 0]]
  };
  var MINOR = { open: 1, close: 1 };

  function play(name, force) {
    var notes = FX[name];
    if ((!on && !force) || !notes) return;
    var now = Date.now();
    if (MINOR[name] && now - lastKey < 450) return;   // a key moment just played (e.g. cart add opening the drawer)
    if (!MINOR[name]) lastKey = now;
    var c = ctx();
    if (!c) return;
    wake();
    if (c.state !== 'running' && c.state !== 'suspended') return;
    var t0 = c.currentTime + 0.01;
    notes.forEach(function (n) {
      try {
        var t = t0 + n[2], d = n[3];
        var o = c.createOscillator(), g = c.createGain();
        o.type = n[4];
        o.frequency.setValueAtTime(n[0], t);
        if (n[1]) o.frequency.exponentialRampToValueAtTime(n[1], t + d);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(n[5], t + 0.008);
        g.gain.exponentialRampToValueAtTime(0.0001, t + d);
        o.connect(g); g.connect(sfxBus);
        var lfo = null;
        if (n[6]) {
          lfo = c.createOscillator(); var lg = c.createGain();
          lfo.frequency.value = n[6]; lg.gain.value = n[0] * 0.02;
          lfo.connect(lg); lg.connect(o.frequency);
          lfo.start(t); lfo.stop(t + d + 0.03);
        }
        o.start(t); o.stop(t + d + 0.03);
        o.onended = function () { try { o.disconnect(); g.disconnect(); if (lfo) lfo.disconnect(); } catch (e) {} };
      } catch (e) {}
    });
  }

  /* ---------- Ambience ---------- */
  function ensureAmb() {
    if (amb || !src) return amb;
    amb = new Audio();
    amb.crossOrigin = 'anonymous';
    amb.loop = true;
    amb.preload = 'auto';
    amb.setAttribute('playsinline', '');
    amb.src = src;
    var c = ctx();
    if (c && c.createMediaElementSource) {   // gain node so the level is adjustable on iPhone too (element volume is read-only there)
      try {
        var s = c.createMediaElementSource(amb);
        ambGain = c.createGain(); ambGain.gain.value = 0.0001;
        s.connect(ambGain); ambGain.connect(c.destination);
      } catch (e) { ambGain = null; }
    }
    if (!ambGain) amb.volume = 0;
    var t = parseFloat(get(POS, sessionStorage));
    if (t > 0) amb.addEventListener('loadedmetadata', function () {
      try { amb.currentTime = amb.duration ? t % amb.duration : t; } catch (e) {}
    }, { once: true });
    return amb;
  }
  function fade(to, secs) {
    if (ambGain && ac) {
      var g = ambGain.gain, now = ac.currentTime;
      try { g.cancelScheduledValues(now); g.setValueAtTime(Math.max(g.value, 0.0001), now); g.setTargetAtTime(Math.max(to, 0.0001), now, secs / 3); } catch (e) { g.value = to; }
    } else if (amb) {
      var start = amb.volume, steps = 12, i = 0;
      var iv = setInterval(function () { i++; try { amb.volume = Math.max(0, Math.min(1, start + (to - start) * i / steps)); } catch (e) {} if (i >= steps) clearInterval(iv); }, secs * 1000 / steps);
    }
  }
  function audible(m) { return m && m !== amb && !m.paused && !m.ended && !m.muted && m.volume > 0; }
  function othersPlaying() {   // any other audible <video>/<audio> on the page (hero video with sound, product video, ...)
    others = others.filter(audible);
    if (!others.length) {
      var ms = document.querySelectorAll('video,audio');
      for (var i = 0; i < ms.length; i++) if (audible(ms[i])) others.push(ms[i]);
    }
    return others.length > 0;
  }
  function ambWanted() { return on && !quiet && !document.hidden && !othersPlaying(); }
  function startAmb() {
    if (!ambWanted()) return;
    var a = ensureAmb();
    if (!a) return;
    var p, r = null;
    try { p = a.play(); } catch (e) { p = Promise.reject(e); }
    if (ac && ac.state !== 'running') {   // resume() can stay pending without a tap: give it 600 ms
      r = new Promise(function (res) { try { ac.resume().then(res, res); } catch (e) { res(); } setTimeout(res, 600); });
    }
    Promise.all([p, r]).then(function () {
      if (!ambWanted()) { a.pause(); return; }
      if (ac && ac.state !== 'running') { a.pause(); armGesture(); return; }   // context still muted: wait for a tap
      fade(AMB_VOL, 1.5);
    }, function () { try { a.pause(); } catch (e) {} if (ambWanted()) armGesture(); });
  }
  function stopAmb(save) {
    if (!amb) return;
    if (save !== false) set(POS, String(amb.currentTime || 0), sessionStorage);
    fade(0, 0.25);
    var a = amb;
    setTimeout(function () { if (!ambWanted()) a.pause(); }, 300);
  }
  function armGesture() {   // autoplay blocked on this page: start on the visitor's next tap/key
    if (waiting) return;
    waiting = true;
    var go = function () {
      ['pointerup', 'touchend', 'keydown', 'click'].forEach(function (t) { document.removeEventListener(t, go, true); });
      waiting = false;
      wake();
      startAmb();
    };
    ['pointerup', 'touchend', 'keydown', 'click'].forEach(function (t) { document.addEventListener(t, go, true); });
  }

  /* ---------- Toggle ---------- */
  function sync() {
    var btns = document.querySelectorAll('[data-pf-sound-toggle]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      btns[i].title = 'Pit lane sound: ' + (on ? 'on' : 'off');
      var lab = btns[i].querySelector('[data-pf-sound-label]');
      if (lab) lab.textContent = on ? 'On' : 'Off';
      if (!src) src = btns[i].getAttribute('data-src') || '';
    }
  }
  function setOn(v) {
    on = v;
    set(KEY, v ? '1' : '0');
    sync();
    if (v) {
      session('ambient');
      ctx(); wake();
      play('on');
      startAmb();
    } else {
      play('off', true);
      stopAmb();
      session('auto');
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var btn = t.closest('[data-pf-sound-toggle]');
    if (btn) { e.preventDefault(); sync(); setOn(!on); return; }
    if (!on) return;
    var a = t.closest('a[href]');
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    var here = location.pathname.replace(/\/$/, ''), there = u.pathname.replace(/\/$/, '');
    if (there === '/pages/pit-lane' && here !== there) { play('arcade'); set(ARRIVE, '1', sessionStorage); }
    else if (here === '/pages/pit-lane' && there.indexOf('/pages/') === 0 && there !== here) play('coin');
  }, true);

  /* ---------- Key moments ---------- */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!on) return;
    if (e.action === 'add') {
      Promise.resolve(e.promise).then(function (r) { play(r && r.detail && r.detail.didError ? 'error' : 'cart'); }, function () { play('error'); });
    } else if (e.action === 'remove') play('remove');
  });
  document.addEventListener('pf:sfx', function (e) { play(e && e.detail); });
  document.addEventListener('theme-drawer:open', function () { play('open'); });
  document.addEventListener('theme-drawer:close', function () { play('close'); });
  function isSearch(e) { return e.target && e.target.id === 'search-modal'; }
  document.addEventListener('dialog:open', function (e) { if (isSearch(e)) play('open'); }, true);
  document.addEventListener('dialog:close', function (e) { if (isSearch(e)) play('close'); }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!on || !f || !f.getAttribute) return;
    var act = f.getAttribute('action') || '';
    if ((/\/contact/.test(act) || /klaviyo-form/.test(f.className || '')) && !e.defaultPrevented) play('submit');
  }, true);

  /* ---------- Page lifecycle ---------- */
  document.addEventListener('visibilitychange', function () {
    if (!on) return;
    if (document.hidden) stopAmb(); else { if (ac && ac.state === 'interrupted') wake(); startAmb(); }
  });
  window.addEventListener('pagehide', function () { if (amb && !amb.paused) set(POS, String(amb.currentTime || 0), sessionStorage); });
  // Another audible video/audio on the page: step aside while it plays, come back when it stops.
  function mediaChange(e) {
    var m = e.target;
    if (!on || !amb || m === amb || !m || !/^(VIDEO|AUDIO)$/.test(m.tagName)) return;
    if (audible(m)) { if (others.indexOf(m) < 0) others.push(m); stopAmb(); }
    else { others = others.filter(function (x) { return x !== m; }); if (!othersPlaying()) startAmb(); }
  }
  ['play', 'pause', 'ended', 'volumechange', 'emptied', 'error'].forEach(function (t) { document.addEventListener(t, mediaChange, true); });

  function init() {
    quiet = gameOnPage();
    sync();
    if (!on) return;
    session('ambient');
    startAmb();
    if (get(ARRIVE, sessionStorage) === '1') {
      set(ARRIVE, '0', sessionStorage);
      if (location.pathname.replace(/\/$/, '') === '/pages/pit-lane') { ctx(); wake(); if (ac && ac.state === 'running') play('arcade'); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.PFSound = { play: function (n) { play(n); }, isOn: function () { return on; }, set: setOn };
})();
